import { getContext } from '@fiverr-private/fiverr_context';
import { ListingType } from '../../lib/constants/listingType';

export const useIsDiscountPage = () => {
    const { type: discountType } = getContext().queryParameters ?? {};

    return discountType === ListingType.Special;
};
